/**
 * EC Section Manager
 * 主入口：管理和注册所有 EC Section Web Components
 * 
 * 架构说明：
 * - 每个 section 是一个独立的 Web Component
 * - 直接导入所有组件，不使用动态加载
 * - 统一的组件注册和管理机制
 */

// 直接导入所有组件
import components from './index.js';

class ECSectionManager {
  constructor() {
    this.registeredComponents = new Set();
  }

  /**
   * 注册所有组件
   */
  registerAll() {
    // 只注册 ec- 前缀的组件
    Object.entries(components).forEach(([name, ComponentClass]) => {
      if (name.startsWith('ec-')) {
        this.register(name, ComponentClass);
      }
    });
  }

  /**
   * 注册一个组件
   */
  register(name, componentClass) {
    // 如果已经注册，跳过
    if (this.registeredComponents.has(name)) {
      return;
    }

    // 检查是否已经定义
    if (customElements.get(name)) {
      console.log(`Component ${name} is already defined`);
      this.registeredComponents.add(name);
      return;
    }

    try {
      customElements.define(name, componentClass);
      this.registeredComponents.add(name);
      console.log(`✓ Component ${name} registered`);
    } catch (error) {
      console.error(`Failed to register component ${name}:`, error);
    }
  }

  /**
   * 初始化管理器
   */
  init() {
    this.registerAll();
    console.log('EC Section Manager initialized');
  }
}

// 创建全局管理器实例
const ecSectionManager = new ECSectionManager();

// DOM 加载完成后自动初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ecSectionManager.init());
} else {
  ecSectionManager.init();
}

// 导出管理器（用于手动控制）
export default ecSectionManager;
